export default {
    data() {
        return { callBackTracker: [] }
    },

    created()       { this.disableCallbacks() },
    beforeUnmount() { this.disableCallbacks() },

    beforeRouteLeave(to, from, next) {
        this.disableCallbacks()
        next()
    },

    methods: {
        disableCallbacks() {
            if(this.callBackTracker)
                this.callBackTracker.forEach( undo => undo() )
        },

        trackCallback(callable) {
            this.callBackTracker.push( callable )
        }
    }
}